/**
 * additional-search-results-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Message, MessageTag, ReplyVerifyingMessage } from "../general/";

/**
 * The client sends an {@link AdditionalSearchResultsRequest} to retrieve more
 * search results after receiving a truncated list (as noted by canGetMoredata
 * on {@link SubjectContextSearchResponse})
 */
export class AdditionalSearchResultsRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_ADDITIONAL_SEARCH_RESULTS;
  public static tag : MessageTag = MessageTag.REQ_ADDITIONAL_SEARCH_RESULTS;

  public verifyReply (reply : Message) : boolean
  {
    return Message.isA(reply, MessageTag.RSP_SUBJECT_CONTEXT_SEARCH);
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/search/additional-search-results-request.ts